export const country = {
  china: "中国",
  korea: "韓国",
  russia: "ロシア",
};
